export type EndDateInput = Date | string | number | null | undefined;

export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAYS_MS = 24 * HOUR_MS;

export function toValidDate(input: EndDateInput): Date | null {
  if (input === null || input === undefined) return null;
  const asDate = input instanceof Date ? input : new Date(input);
  return Number.isNaN(asDate.getTime()) ? null : asDate;
}

export function pad2(value: number): string {
  return String(value).padStart(2, "0");
}

export function getTimeLeftParts(
  endDate: Date,
  now: Date = new Date()
): {
  diffMs: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} {
  const diffMs = Math.max(0, endDate.getTime() - now.getTime());

  const days = Math.floor(diffMs / DAYS_MS);
  const hours = Math.floor((diffMs % DAYS_MS) / HOUR_MS);
  const minutes = Math.floor((diffMs % HOUR_MS) / MINUTE_MS);
  const seconds = Math.floor((diffMs % MINUTE_MS) / SECOND_MS);

  return { diffMs, days, hours, minutes, seconds };
}
